import CustomButton from "../../../../atoms/CustomButton";
import { CheckCheck } from "lucide-react";
import Modal from "../../../../organisms/modals/Modal";
import SubtaskForm from "../SubtaskForm/index";

const SubtaskView = ({
  logData,
  setLogData,
  task_id,
  open,
  setOpen,
  name,
  refetchData,
  dirtyFlag,
  setSubtaskOpen,
  disabled,
}) => {
  return (
    <>
      <CustomButton
        icon={<CheckCheck size={14} />}
        text="Add subtask"
        handleClick={() => setOpen(true)}
        disabled={disabled}
      />

      {open && (
        <Modal
          isActive={open}
          title={`${
            logData.editingSubtask ? "Edit" : "Add"
          } Subtask ${name ? `- ${name.length > 22 ? `${name.slice(0, 22)}...` : name}` : ""}`}
          width="500px"
          maxHeight={"500px"}
          onClose={() => {
            setOpen(false);
            setLogData((prev) => ({ ...prev, editingSubtask: null })); 
          }}
        >
          <SubtaskForm
            setSubtaskOpen={setSubtaskOpen}
            setOpen={setOpen}
            prevData={logData}
            setPrevData={setLogData}
            task_id={task_id}
            initialValues={logData.editingSubtask || {}}
            name={name}
            refetchData={refetchData}
            dirtyFlag={dirtyFlag}
          />
        </Modal>
      )}
    </>
  );
};

export default SubtaskView;